module.exports = __webpack_public_path__ + "static/media/dpi.0b1ef637.png";